import { PromiseCompletionSource } from "scene-manager";
import { PreloaderModel } from "../models/PreloaderModel";
import { PreloaderResourcesPackage } from "../resources/PreloaderResourcesPackage";
import { nameof } from "bindable-data";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { PreloaderController } from "../controllers/PreloaderContorller";
import { IDestroyOptions } from "@pixi/display";
import { Sprite } from "@pixi/sprite";
import { ProgressBar } from "../../../common/components/ProgressBar";
import { AdaptiveView } from "../../../common/views/AdaptiveView";
import { FullScreenBackground } from "../../../common/components/FullScreenBackground";
import { BackgroundResourcesPackage } from "../../../common/resources/BackgroundResourcesPackage";

export class PreloaderView extends AdaptiveView<void> {
    private background: FullScreenBackground;
    private logo: Sprite;
    private progressBar: ProgressBar;

    public constructor(
        private readonly backgroundResources: BackgroundResourcesPackage,
        private readonly preloaderResources: PreloaderResourcesPackage,
        private readonly preloaderModel: PreloaderModel,
        private readonly preloaderController: PreloaderController,
        canvasScaler: ICanvasScaler,
        operationControls: PromiseCompletionSource<void>
    ) {
        super(canvasScaler, operationControls);
        this.build();
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);

        this.preloaderModel.propertyChanged.add(this.onPreloaderModelPropertyChange, this);
        this.onPreloaderModelPropertyChange(this.preloaderModel, nameof(this.preloaderModel, "loadingProgress"));
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.preloaderModel.propertyChanged.remove(this.onPreloaderModelPropertyChange, this);
        super.destroy(options);
    }

    public async start(): Promise<void> {
        await this.preloaderController.startPreloading();
        this.preloaderController.showMenu(this.operationControls);
    }

    private build(): void {
        this.background = new FullScreenBackground(this.canvasScaler, this.backgroundResources.assets_backgrounds_background_png);
        this.logo = new Sprite(this.backgroundResources.assets_backgrounds_logo_png);
        this.progressBar = new ProgressBar(this.preloaderResources.assets_preloader_progress_bar_bg_png, this.preloaderResources.assets_preloader_progress_bar_png, 0);
        this.progressBar.updateProgressPosition(32, 19);

        this.addChild(this.background, this.logo, this.progressBar);
    }

    protected layout(_width: number, height: number): void {
        switch (height) {
            case 2400:
                this.layout9x20();
                break;
            case 1620:
                this.layout10x9();
                break;
            case 1800:
                this.layout4x3();
                break;
        }
    }

    private layout9x20(): void {
        this.logo.position.set((this.canvasScaler.referenceWidth - this.logo.width) * 0.5, 450);
        this.progressBar.position.set(101, 1715);
    }

    private layout10x9(): void {
        this.logo.position.set((this.canvasScaler.referenceWidth - this.logo.width) * 0.5, 300);
        this.progressBar.position.set(1001, 1211);
    }

    private layout4x3(): void {
        this.logo.position.set((this.canvasScaler.referenceWidth - this.logo.width) * 0.5, 350);
        this.progressBar.position.set(761, 1301);
    }

    private onPreloaderModelPropertyChange(model: PreloaderModel, property: string): void {
        switch (property) {
            case nameof(model, "loadingProgress"):
                console.log(`Loading progress: ${model.loadingProgress.value}`);
                this.progressBar.value = model.loadingProgress.value;
                break;
        }
    }
}
